export const GENERAL_INSURANCE_DATA_SAVED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.GeneralInsuranceDataSaved";
export const INSURANCE_SIMULATION_SAVED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.InsuranceSimulationSaved";
export const CONVENTIONS_QUOTATIONS_SAVED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.ConventionsQuotationsSaved";
export const QUOTATIONS_COMPUTED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.QuotationsComputed";
export const RTI_OPTION_UPDATED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.RtiOptionUpdated";
export const INSURANCE_QUOTATION_SELECTED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.InsuranceQuotationSelected";
export const CASCO_QUOTATION_UPDATED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.CascoQuotationUpdated";
export const INSURANCE_FINANCING_OFFER_SAVED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.InsuranceFinancingOfferSaved";
export const RCA_QUOTATION_UPDATED_EVENT =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Insurances.RcaQuotationUpdated";
